﻿import $ from 'jquery';
import { Remote, IRemoteOptions, IRemoteHandler } from "./remote";
import Ajax from "./ajax";

export class SelectRemoteHandler implements IRemoteHandler {
  public handle($element: JQuery, options: IRemoteOptions): boolean {
    var shouldHandle = $element.is("select") && $element.isEnabled();
    if (!shouldHandle)
      return false;

    options.$triggeringEvent?.preventDefault();

    var value = $element.val();

    options.url = options.url || $element.find('option[value="' + value + '"]').data('url');

    if (!options.url)
      options.url = $element.data('url');

    options.type = options.type || $element.data('method') || 'get';

    Ajax.execute($element, options);
    return true;
  }
}
